import { putData } from "../base.ehq.model";
import { serialize } from "./user-confirmation.serializer";
import { deserialize } from "../base.serializer";

export const postUserConfirmation = async (
  token: string,
  baseUrl: string,
  userId: number | string,
  body: any,
  config?: any
): Promise<any> => {
  const queryPath = `${baseUrl}/users/${userId}/confirm`;

  const serializedBody = await serialize(body);

  return await putData(token, queryPath, {}, serializedBody, config).then(
    async (response) => {
      return await deserialize(response.data);
    }
  );
};
